<div class="procedures-list">
  @if ((null == selectedProcedure || '' == selectedProcedure) && inProgressProceduresList.length > 0) {
    <h2>Actions en cours</h2>
  }
  @if ((null == selectedProcedure || '' == selectedProcedure) && inProgressProceduresList.length > 0) {
    <div class="procedure-grid w-100 mb-4">
      @for (procedure of inProgressProceduresList; track procedure) {
        <div class="col-12" (click)="displayMessage(procedure)">
          <app-procedure-card [icon]="'icons/procedures/customer/'+procedure.code+'.png'" [cursor]="true" [text]="procedure.label"></app-procedure-card>
        </div>
      }
    </div>
  }
  @if ((null == selectedProcedure || '' == selectedProcedure) && activeProceduresList.length > 0) {
    <h2>Actions disponibles</h2>
  }
  @if ((null == selectedProcedure || '' == selectedProcedure) && activeProceduresList.length > 0) {
    <div class="procedure-grid w-100 mb-4">
      @for (procedure of activeProceduresList; track procedure) {
        <div class="col-12" (click)="getProcedure(procedure)">
          <app-procedure-card [icon]="'icons/procedures/customer/'+procedure.code+'.png'" [cursor]="true" [text]="procedure.label"></app-procedure-card>
        </div>
      }
    </div>
  }
</div>

<!--app-not-received-payment *ngIf="constHelper.PROCEDURE_NOT_RECEIVED_PAYMENT == selectedProcedure" [step]="step"></app-not-received-payment-->
@if (constHelper.PROCEDURE_CREDIT_MY_ACCOUNT == selectedProcedure) {
  <app-credit-account></app-credit-account>
}